import { AttendedMeeting, GoogleCalendarEvent, isAttendedMeeting } from '@/api/custom';
import { captureMessage } from '@/sentry';

type MeetingNotesUsageAction = 'view' | 'edit' | 'save' | 'copy' | 'download';
type MeetingNotesUsageArtifact = 'meeting' | 'notes' | 'transcript' | 'recording';
type MeetingNotesUsageResult = 'attempted' | 'succeeded' | 'failed';

type MeetingNotesUsageEvent = {
  action: MeetingNotesUsageAction;
  artifact: MeetingNotesUsageArtifact;
  meeting: GoogleCalendarEvent | AttendedMeeting | null;
  result?: MeetingNotesUsageResult;
};

export const trackMeetingNotesUsage = ({
  action,
  artifact,
  meeting,
  result = 'attempted',
}: MeetingNotesUsageEvent): void => {
  if (!meeting || !isAttendedMeeting(meeting)) return;

  captureMessage(`meeting_notes_usage.${action}.${artifact}.${result}`, 'info', {
    feature: 'meeting_notes',
    page: 'meeting_hub',
    action,
    artifact,
    result,
    job_id: meeting.job_id,
    status: meeting.status,
    meeting_memory_status: meeting.meeting_memory_status ?? 'not_applicable',
    has_summary_file: Boolean(meeting.summary_file_key),
    has_transcript_file: Boolean(meeting.transcript_file_key),
    has_recording: Boolean(meeting.recording_link),
  });
};
